/**
 * GÖREV TÜRÜ VE DURUMUNUN EKRANDAKİ KARŞILIKLARI
 *
 * ================================================================
 * AYNI SÖZLÜK İKİ DOSYADAYDI — BİREBİR KOPYA
 * ================================================================
 * `TUR_ADI` hem `GorevKarti.tsx` hem `HaftalikProgram.tsx` içinde,
 * **byte byte aynı** yazılıydı (04.09.2026'da ölçüldü). Prisma'ya
 * sekizinci bir `TaskKind` eklendiği gün ikisinden birine label
 * eklenip ötekinin unutulması işten değil; unutulan tarafta öğrenci
 * ham enum adını görür — "QUESTION_SOLVING" gibi.
 *
 * Bu, ana oturumun `COZULDU_ICIN_ARDISIK_DOGRU`da kapattığı sınıfın
 * aynısı: aynı kural, birden fazla ev. Burada ev tekleşti ve
 * `gorev-etiketleri.test.ts` sözlüklerin **şemayla** örtüştüğünü
 * ölçüyor — yani eksik bir label artık sessiz kalamıyor.
 *
 * Neden `packages/contracts` değil: bunlar sunucunun bildiği bir
 * KURAL değil, öğrenciye gösterilen Türkçe metin. Panel aynı enum'a
 * başka bir dille bakıyor (uzmanın diliyle). Sözleşmeye taşımak iki
 * ayrı hedef kitlenin metnini tek yere yığardı.
 */

/** `TaskKind` — öğrenciye görünen karşılıklar. */
export const TUR_ADI: Record<string, string> = {
  QUESTION_SOLVING: "Soru çözümü",
  TOPIC_STUDY: "Konu çalışması",
  REVIEW: "Tekrar",
  MOCK_EXAM: "Deneme",
  VIDEO: "Video",
  READING: "Okuma",
  OTHER: "Diğer",
};

/**
 * `TaskItemStatus` — `gosterilecekDurum` alanının alabileceği değerler.
 *
 * Sunucudaki `gorevDurumu()` dönüş tipi tam olarak `TaskItemStatus`;
 * yani bu sözlük şemadaki sekiz değerin hepsini karşılamak zorunda.
 *
 * ================================================================
 * RENK TEK BAŞINA ANLAM TAŞIMAZ
 * ================================================================
 * Şartname açıkça söylüyor: "Renk tek başına anlam taşımaz — her
 * duruma ikon ve metin eşlik eder." Bu bir süslemenin değil,
 * erişilebilirliğin gereği: erkeklerin yaklaşık %8'i renk körüdür ve
 * bu yaş grubunda çoğu bunu bilmez.
 *
 * Renkler `tokens.css` belirteçlerinden geliyor; ham renk kodu YOK.
 */
export const DURUM: Record<string, { etiket: string; ikon: string; sinif: string }> = {
  PLANNED: { etiket: "Planlandı", ikon: "◷", sinif: "bg-marka-50 text-marka-700" },
  STARTED: { etiket: "Başlandı", ikon: "▶", sinif: "bg-marka-50 text-marka-700" },
  PENDING: { etiket: "Bekliyor", ikon: "⏳", sinif: "bg-uyari-500/15 text-uyari-600" },
  PARTIAL: { etiket: "Kısmen", ikon: "◐", sinif: "bg-uyari-500/15 text-uyari-600" },
  COMPLETED: { etiket: "Tamamlandı", ikon: "✓", sinif: "bg-basarili-500/15 text-onay-700" },
  POSTPONED: { etiket: "Ertelendi", ikon: "→", sinif: "bg-notr-100 text-notr-600" },
  FAILED: { etiket: "Yapılamadı", ikon: "✕", sinif: "bg-hata-500/10 text-hata-700" },
  AWAITING_REVIEW: { etiket: "Kontrol bekliyor", ikon: "◆", sinif: "bg-marka-50 text-marka-700" },
};
